// Доп. услуги заявки — в админке и в ЛК партнёра. Названия подсказывает
// <datalist> (можно вписать и своё), а при выборе знакомого названия в пустую
// цену подставляется цена последнего использования. Обработчик на документе:
// строки добавляются кнопкой уже после загрузки.
const NEW_SERVICE_INDEX = 'NEW_SERVICE_INDEX'
let addedRows = 0

export function initEventServiceSuggestions() {
  initAddButtons()

  document.addEventListener('input', (event) => {
    const input = event.target
    if (
      !(input instanceof HTMLInputElement) ||
      !input.matches('[data-event-service-name]') ||
      !input.list
    ) {
      return
    }

    const name = input.value.trim().toLowerCase()
    const option = Array.from(input.list.options).find(
      (item) => item.value.toLowerCase() === name
    )
    const price = findPriceInput(input)
    if (!option?.dataset.price || !price || price.value !== '') return

    price.value = option.dataset.price
    price.dispatchEvent(new Event('input', { bubbles: true }))
  })
}

// Цена — ближайшее поле той же строки: разметка строк в админке и в ЛК разная.
function findPriceInput(input: HTMLInputElement) {
  for (
    let node = input.parentElement;
    node && node !== document.body;
    node = node.parentElement
  ) {
    const price = node.querySelector<HTMLInputElement>(
      'input[data-event-service-price]'
    )
    if (price) return price
  }
  return null
}

// Новая строка — копия <template> с уникальным индексом в именах полей:
// Rails собирает services_attributes по нему. Без JS кнопка скрыта, а под
// новую услугу в форме всегда есть одна пустая строка.
function initAddButtons() {
  document
    .querySelectorAll<HTMLElement>('[data-event-services]')
    .forEach((root) => {
      const button = root.querySelector<HTMLButtonElement>(
        '[data-event-service-add]'
      )
      const template = root.querySelector<HTMLTemplateElement>(
        'template[data-event-service-template]'
      )
      const rows = root.querySelector<HTMLElement>('[data-event-service-rows]')
      if (!button || !template || !rows) return

      button.hidden = false
      button.addEventListener('click', () => {
        const index = `${Date.now()}${++addedRows}`
        const html = template.innerHTML.split(NEW_SERVICE_INDEX).join(index)
        rows.insertAdjacentHTML('beforeend', html)
        rows.lastElementChild
          ?.querySelector<HTMLInputElement>('[data-event-service-name]')
          ?.focus()
      })
    })
}
